type Resettable<T> = T & { reset: () => void };

export function once<T extends (...args: any[]) => any>(fn: T): Resettable<T> {
  let result: ReturnType<T>;
  let called = false;

  const memoized = ((...args: any[]) => {
    if (!called) {
      result = fn(...args);
      called = true;
    }

    return result;
  }) as T & { reset: () => void };

  memoized.reset = () => {
    called = false;
  };

  return memoized;
}
